<template>
    <div class="quote">
        <div :class="{ 'no-purchase': hidePurchase }" class="quote-item">
            <div class="logo" :class="{ 'flex-column': type === 'pet' }">
                <div class="logo-container">
                    <img
                        v-if="!hideLogo"
                        :alt="quote.company"
                        :src="quote.logo"
                        :title="quote.company"
                    />
                    <img v-if="hideLogo" src="/images/logo_2.png" />
                </div>
                <div class="fnx-pet-branch" v-if="type === 'pet'">
                    {{ ("quote-results.pet.branch_" + quote.branch) | __ }}
                </div>
            </div>

            <div class="details details-desc">
                <div class="details-wrap">
                    <div class="header-container"></div>
                    <div class="detail-top">
                        <template v-for="(line, j) in quote.coverages">
                            <div
                                :key="j"
                                v-if="j !== 0"
                                class="detail-item-first"
                            >
                                <div class="type">
                                    <p>{{ line.label }}:</p>
                                </div>
                                <div class="price">
                                    {{ getValueOrUnlimited(line.value) }}
                                </div>
                            </div>
                        </template>

                        <component
                            :is="innerItems[type]"
                            :currency="currency"
                            :type="type"
                            :innerProps="innerProps"
                            :branch="quote.branch"
                        />
                    </div>

                    <div class="bottom-container">
                        <div class="bottom">
                            <a class="cursor-pointer" @click="policyClickEvent">
                                {{ "quote-results.static.policy_details" | __ }}
                            </a>
                        </div>
                        <div class="bottom" v-if="type === 'car'">
                            <a
                                class="cursor-pointer"
                                @click="protectionClickClickEvent"
                            >
                                {{
                                    "quote-results.static.protection_requirements"
                                        | __
                                }}
                            </a>
                        </div>
                    </div>

                    <div v-if="!hidePurchase" class="link mobile-button mt-10">
                        <a :href="quote.link">
                            <span class="text">
                                {{ "quote-results.static.buy" | __ }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <div class="price big">
                <div class="price-logo-mobile mx-auto">
                    <div class="logo-container mobile-logo">
                        <img
                            v-if="!hideLogo"
                            :alt="quote.company"
                            :src="quote.logo"
                            :title="quote.company"
                        />
                        <img v-if="hideLogo" src="/images/logo_2.png" />
                    </div>
                    <div class="price-tag lg:xl:flex">
                        <p>
                            <span v-if="type === 'car'">{{
                                displayPrice
                            }}</span>
                            <span v-else>{{ quote.total }}</span>
                            <span>{{ currency }}</span>
                        </p>
                        <div
                            v-if="type === 'car'"
                            class="lg:xl:flex lg:xl:items-end mr-2 text-sm text-gray-500"
                        >
                            <span style="direction: rtl;" class="table">
                                <span class="table-cell">{{
                                    "quote-results.static.per_month" | __
                                }}</span>
                                <span class="table-cell">(</span>
                                <span class="table-cell">x</span>
                                <span class="table-cell">10</span>
                                <span class="table-cell">=</span>
                                <span class="table-cell">{{
                                    quote.total
                                }}</span>
                                <span class="table-cell">{{ currency }}</span>
                                <span class="table-cell">)</span>
                            </span>
                        </div>
                        <div
                            v-if="type === 'pet'"
                            class="flex items-end mr-2 text-sm text-gray-500"
                        >
                            {{ "quote-results.pet.month" | __ }}
                        </div>
                    </div>
                </div>

                <div class="quote-lines" v-if="quote.lines">
                    <div
                        :key="j"
                        v-for="(line, j) in quote.lines"
                        class="detail-item-first"
                    >
                        <div class="type">
                            <p>
                                {{ line.label.split(" ")[1] }}:
                                <span>{{ line.value }} {{ currency }}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="!hidePurchase" class="link link-desc mt-10">
                    <a
                        :href="quote.link"
                        :target="quote.isExternalPurchaser ? '_blank' : '_self'"
                        :rel="
                            quote.isExternalPurchaser
                                ? 'noopener noreferrer'
                                : ''
                        "
                    >
                        <span class="text">
                            {{ "quote-results.static.buy" | __ }}
                        </span>
                    </a>
                </div>
            </div>

            <div class="mobile-section">
                <div v-if="!hidePurchase" class="link">
                    <a
                        :href="quote.link"
                        :target="quote.isExternalPurchaser ? '_blank' : '_self'"
                        :rel="
                            quote.isExternalPurchaser
                                ? 'noopener noreferrer'
                                : ''
                        "
                    >
                        <span class="text">
                            {{ "quote-results.static.buy" | __ }}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CarItem from "./quote-generic-items/CarItem.vue";
import TravelItem from "./quote-generic-items/TravelItem.vue";
import PetItem from "./quote-generic-items/PetItem.vue";
import HomeItem from "./quote-generic-items/HomeItem.vue";

export default {
    components: {
        CarItem,
        TravelItem,
        PetItem,
        HomeItem
    },

    data() {
        if (
            this.quote &&
            this.quote.protection_levels &&
            this.quote.protection_levels[0]
        ) {
            let levelDescription = String(
                this.quote.protection_levels[0].description
            )
                .substring(0, 70)
                .split(" ");
            levelDescription.pop();

            let levelName = this.quote.protection_levels[0].name
                .substring(0, 70)
                .split(" ");
            levelName.pop();

            return {
                shortDescription: levelDescription.join(" ") + "...",
                shortName: levelName.join(" ") + "..."
            };
        }

        // Handle the case when data is not available or does not match the expected structure
        return {
            shortDescription: "",
            shortName: ""
        };
    },

    props: {
        quote: Object,
        type: String,
        hidePurchase: Boolean,
        hideLogo: {
            type: Boolean,
            default: false
        },
        policyIncludesKeys: {
            type: Array,
            default: function() {
                return {};
            }
        }
    },

    methods: {
        protectionClickClickEvent() {
            this.$emit("protection-click");
        },
        policyClickEvent() {
            this.$emit("details-click");
        },
        getValueOrUnlimited(value) {
            if (value === null) {
                return this.$trans("quote-results.static.notAvailable");
            } else if (value === -1) {
                return this.$trans("quote-results.static.unlimited");
            } else if (value === -2) {
                return this.$trans("quote-results.static.without");
            }
            return `${value} ${this.currency}`;
        }
    },

    computed: {
        innerItems() {
            return {
                car: "car-item",
                travel: "travel-item",
                pet: "pet-item",
                home: "home-item"
            };
        },
        innerProps() {
            return this.quote.policyIncludes[this.type];
        },
        currency() {
            const currencySign = {
                car: "₪",
                pet: "₪",
                home: "₪",
                travel: "$"
            };

            return currencySign[this.type];
        },
        onePaymentPrice() {
            // Remove commas from the total amount and convert it to a number
            const totalAmount = parseFloat(this.quote.total.replace(/,/g, ""));

            // divide the total price by 10 and round it to the nearest integer using floor
            const onePayment = Math.floor(totalAmount / 10);

            // Format the result with commas as separators
            return onePayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        displayPrice() {
            // Check if type is 'car' and display total price or monthly payment accordingly
            if (this.type === "car") {
                return this.onePaymentPrice;
            } else {
                return this.quote.total;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.quote {
    border-radius: 5px;
    border: 1px solid rgba(33, 67, 146, 0.2);
    background: $lightest-gray;
    margin-bottom: 35px;
    position: relative;
    height: 208px;

    @media screen and (max-width: $desktop) {
        justify-content: center;
        height: auto;
        max-width: 95%;
        margin: auto;
    }

    .quote-item .mobile-section {
        height: 208px;
        display: none;

        a.coverages {
            text-align: center;
            width: 100%;
            display: block;
            margin: 15px 0;
            text-decoration: none;
            font-size: 23px;
        }
    }

    .quote-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        height: 100%;

        @media screen and (max-width: $mobile) {
            //flex-wrap: wrap;
            justify-content: center;
            flex-direction: column-reverse;
        }

        &.no-purchase {
            > div {
                width: 33.3%;

                &.details {
                    width: 33.3%;
                }

                @media (max-width: $tablet) {
                    width: 100%;

                    &.details {
                        width: 100%;
                    }
                }
            }
        }

        > div {
            position: relative;

            @media screen and (max-width: $mobile) {
                //width: 50% !important;
                min-height: 0;
            }

            &:last-child {
                &:after {
                    content: none;
                }
            }
        }

        .logo {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 1;
            position: relative;
        }

        .logo-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            width: 190px;
            border-radius: 70px;
            border: 1px solid $black;
            background: $white;
            height: 68px;

            &.mobile-logo {
                display: none;
            }

            @media screen and (max-width: $mobile) {
                // position: absolute;
                // bottom: 270px;
                // right: 60px;
                width: 81px;
                height: 22px;
                border-radius: 45px;
                border: 0.5px solid $black;
                background: $white;
                display: none;

                &.mobile-logo {
                    display: flex;
                    height: 40px;
                    width: 90px;
                }
            }

            img {
                width: 50%;
                height: auto;

                object-fit: contain;
                object-position: center;
                padding: 10px;

                @media screen and (max-width: $mobile) {
                    padding: unset;
                    width: 70%;
                    height: 100%;
                }
            }
        }

        .details {
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 2;
            height: 100%;

            @media screen and (max-width: $mobile) {
                width: 100%;
            }

            .details-wrap {
                width: 100%;
                height: 100%;
                padding: 40px;
                display: flex;
                justify-content: center;
                flex-direction: column;

                @media screen and (max-width: $desktop) {
                    padding: 10px;
                }

                @media screen and (max-width: $mobile) {
                    padding: 20px;
                    width: 100%;
                    height: auto;
                    justify-content: flex-start;
                }

                .header-container {
                    margin-bottom: 20px;

                    @media screen and (max-width: $mobile) {
                        margin-bottom: unset;
                    }

                    p {
                        width: 100%;
                        color: $black;
                        font-size: 24px;
                        font-weight: $font-bold;

                        @media screen and (max-width: $mobile) {
                            font-size: 18px;
                        }
                    }
                }

                .bottom-container {
                    display: flex;
                    flex-direction: row;
                    padding-left: 60px;
                    justify-content: space-between;

                    @media screen and (max-width: $mobile) {
                        padding-left: unset;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                        margin-top: 10px;
                        gap: 15%;
                    }
                }

                .bottom {
                    text-align: center;
                    display: block;

                    a {
                        text-decoration: none;
                        position: relative;
                        color: var(--blue, $primary-blue);
                        text-align: center;
                        font-size: 18px;
                        font-weight: $font-bold;

                        @media screen and (max-width: $mobile) {
                            font-size: 16px;
                        }
                    }

                    a::after {
                        margin-right: -60px;
                        margin-top: 8px;
                        position: absolute;
                        content: "";
                        background-size: 10px;
                        height: 100%;
                        background-repeat: no-repeat;
                        width: 100%;
                        background-image: url("data:image/svg+xml,%0A%3Csvg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.76559 7.41647L2.66834 7.5L2.76559 7.58353L8.65044 12.6377C9.05825 12.988 9.05825 13.5479 8.65044 13.8982C8.23272 14.2569 7.54953 14.2569 7.13181 13.8982L0.415924 8.13022C0.00810557 7.77996 0.00810551 7.22004 0.415924 6.86978L7.13181 1.10183C7.54953 0.743072 8.23272 0.743072 8.65043 1.10183C9.05825 1.45208 9.05825 2.01201 8.65044 2.36227L2.76559 7.41647Z' fill='%23185AF5' stroke='white' stroke-width='0.220212'/%3E%3C/svg%3E%0A");
                    }
                }

                .detail-top {
                    display: flex;
                    gap: 30px;
                    margin-bottom: 40px;

                    @media screen and (max-width: $tablet) {
                        margin-bottom: 20px;
                    }

                    @media screen and (max-width: $mobile) {
                        gap: unset;
                        margin-bottom: unset;
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .detail-item-first {
                        text-align: center;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 7px;
                    }

                    .type {
                        p {
                            color: $black;
                            text-align: center;
                            font-size: 20px;
                            font-weight: $font-light;

                            @media screen and (max-width: $tablet) {
                                text-align: right;
                                font-size: 15px;
                            }

                            @media screen and (max-width: $mobile) {
                                text-align: right;
                                font-size: 14px;
                            }
                        }
                    }

                    .price {
                        color: $black;
                        text-align: center;
                        font-size: 20px;
                        font-weight: $font-bold;

                        @media screen and (max-width: $tablet) {
                            font-size: 15px;
                        }

                        @media screen and (max-width: $mobile) {
                            font-size: 14px;
                            font-weight: $font-normal;
                        }
                    }
                }
            }
        }

        .price.big {
            display: flex;
            align-items: flex-start;
            justify-content: center;
            flex-direction: column;
            flex: 1;
            padding: 20px;

            @media screen and (max-width: $desktop) {
                padding: 0 20px;
                gap: 10px;
            }

            @media screen and (max-width: $mobile) {
                padding: 20px;
                width: 100%;
            }

            &:after {
                content: none !important;
            }

            .quote-lines {
                width: 100%;
                display: flex;
                justify-content: space-between;

                @media (max-width: $mobile) {
                    justify-content: unset;
                    gap: 20px;
                }

                p {
                    color: $black;
                    text-align: center;
                    font-size: 16px;
                    font-style: normal;

                    span {
                        font-weight: $font-bold;
                        font-size: 20px;

                        @media screen and (max-width: $mobile) {
                            font-weight: $font-normal;
                        }
                    }
                }
            }

            .price-tag {
                margin-bottom: 15px;

                p {
                    color: $black;
                    text-align: center;
                    font-size: 40px;
                    font-style: normal;
                    font-weight: $font-bold;
                    line-height: 1;

                    @media screen and (max-width: $mobile) {
                        font-size: 26px;
                    }

                    span {
                        // font-size: 20px;
                    }
                }
            }
        }

        .link {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 100%;

            @media screen and (max-width: $mobile) {
                width: auto;
            }

            .protections {
                margin-top: 14px;
                padding: 0 50px;
                font-size: 18px;
                font-weight: $font-light;
                line-height: 1.28;
                text-align: center;
                color: $black;
            }

            a {
                display: inline-flex;
                color: $white;
                text-decoration: none;
                font-size: 20px;
                font-weight: bold;
                height: 40px;
                align-items: center;
                width: 100%;
                padding: 9.88px 73.396px;
                justify-content: center;
                border-radius: 70.573px;
                background: #3457ee;

                .text {
                    transition: all 150ms ease;
                    margin: 0 10px;
                }
            }

            &:hover {
                .text {
                    margin: 0 13px;
                }
            }

            &.link-desc {
                @media screen and (max-width: $mobile) {
                    display: none;
                }
            }

            &.mobile-button {
                display: none;

                @media screen and (max-width: $mobile) {
                    display: flex;
                }
            }
        }
    }
}

.link-desc {
    @media screen and (max-width: $mobile) {
    }
}

.details-desc {
    &:after,
    &:before {
        content: "";
        display: block;
        width: 1px;
        background: #cfd5e5;
        height: 100%;
        position: absolute;
        left: 0;

        @media screen and (max-width: $mobile) {
            height: 1px;
            width: 100%;
            top: 0;
        }
    }

    &:before {
        right: 0;
        left: unset;

        @media screen and (max-width: $mobile) {
            height: 1px;
            width: 100%;
            top: 0;
        }
    }

    @media screen and (max-width: $mobile) {
        //display: none !important;
    }
}

.price-logo-mobile {
    @media screen and (max-width: $mobile) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
}

.flex-column {
    flex-direction: column;
}

.table-cell {
    padding: 0 2px;
}
</style>
